const CYRILLIC_TO_LATIN = { А: 'A', В: 'B', С: 'C', а: 'A', в: 'B', с: 'C' };

const LANGUAGE_PREFIX = /^\s*(?:курс\s+)?[\p{L}ʼ'’-]+\s+мов[аи](?=[\s,.:-]|$)[\s,.:-]*/iu;

const ORDINAL = '(?:\\s*-?\\s*(?:й|ий|ій|го|ого|th|st|nd|rd))?';

const PATTERNS = [
  {
    regex: /(^|[^\p{L}\d])([ABCАВСabcавс][0-2](?:[.+]\d)?)(?![\p{L}\d])/gu,
    read: (m) => {
      const level = m[2].replace(/^[АВСавс]/u, (ch) => CYRILLIC_TO_LATIN[ch] || ch).toUpperCase();
      return { level, rank: (level.charCodeAt(0) - 64) * 10 + Number(level[1]) };
    },
    offset: (m) => m[1].length,
  },
  {
    regex: new RegExp(`(?:HSK\\s*(\\d)|(\\d)${ORDINAL}\\s*HSK)`, 'giu'),
    read: (m) => ({ level: `HSK ${m[1] || m[2]}`, rank: Number(m[1] || m[2]) }),
  },
  {
    regex: new RegExp(`(?:ГИП\\s*(\\d)|(\\d)${ORDINAL}\\s*ГИП)`, 'gu'),
    read: (m) => ({ level: `ГИП ${m[1] || m[2]}`, rank: Number(m[1] || m[2]) }),
  },
  {
    regex: /TOPIK\s*(I{1,2}|\d)/giu,
    read: (m) => {
      const value = m[1].toUpperCase();
      return { level: `TOPIK ${value}`, rank: /^\d$/.test(value) ? Number(value) : value.length };
    },
  },
  {
    regex: /(^|[^\p{L}\d])(N[0-5])(?![\p{L}\d])/gu,
    read: (m) => ({ level: m[2], rank: 10 - Number(m[2][1]) }),
    offset: (m) => m[1].length,
  },
];

const findLevels = (text) => {
  for (const pattern of PATTERNS) {
    const found = [...text.matchAll(pattern.regex)].map((m) => {
      const start = m.index + (pattern.offset ? pattern.offset(m) : 0);
      const length = m[0].length - (pattern.offset ? pattern.offset(m) : 0);

      return { ...pattern.read(m), start, length };
    });

    if (found.length > 0) {
      return found;
    }
  }

  return [];
};

const cleanExtra = (text) => text
  .replace(LANGUAGE_PREFIX, '')
  .replace(/\([^)]*рів[^)]*\)/giu, ' ')
  .replace(/(^|\s)v\d+(?:\.\d+)*(?=\s|$)/giu, ' ')
  .replace(/(^|\s)(?:рівень|рівні|рівня)(?=\s|$)/giu, ' ')
  .replace(/(^|\s)(?:і|та|й|до|and)(?=\s|$)/giu, ' ')
  .replace(/^[\s,.:·/–-]+|[\s,.:·/–-]+$/gu, '')
  .replace(/\s{2,}/g, ' ')
  .trim();

export function formatCourseLevel(programName) {
  const name = String(programName || '').trim();
  if (!name) {
    return '';
  }

  const levels = findLevels(name);
  if (levels.length === 0) {
    return name;
  }

  const top = levels.reduce((best, item) => (item.rank >= best.rank ? item : best), levels[0]);

  let rest = name;
  [...levels].sort((a, b) => b.start - a.start).forEach((item) => {
    rest = `${rest.slice(0, item.start)} ${rest.slice(item.start + item.length)}`;
  });

  const extra = cleanExtra(rest.replace(/\s*[-–/]\s*(?=\s|$)/gu, ' '));

  return extra ? `Рівень ${top.level} · ${extra}` : `Рівень ${top.level}`;
}
